module.exports = __webpack_public_path__ + "static/media/Layer 14.b6169f6d.webp";